import { isEqual, sortBy } from 'lodash'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import ChapterItem from './ChapterItem'

const initialState = {
    index: [],
    expandEverything: false,
}

const Chapter = ({ block }) => {
    const [openSubChapter, setOpenSubChapter] = useState(initialState)
    const hasPlainTextChapterItem = block?.childrens.some(
        (child) => child.block === 'ChapitreItem' && child.style === 'plain_text'
    )

    let indexes = block?.childrens.map((block, index) => index)

    const indexIsEqual = useMemo(() => {
        return isEqual(sortBy(openSubChapter?.index), sortBy(indexes))
    }, [openSubChapter, indexes])

    useEffect(() => {
        if (indexIsEqual) {
            setOpenSubChapter((prev) => ({
                ...prev,
                expandEverything: true,
            }))
        }
    }, [indexIsEqual])

    const onClickExpandEverything = useCallback(() => {
        setOpenSubChapter({
            index: !openSubChapter?.expandEverything ? indexes : [],
            expandEverything: !openSubChapter?.expandEverything,
        })
    }, [block, openSubChapter])

    return (
        <section className="baseocom-chapter-block">
            {!hasPlainTextChapterItem ? (
                <button className="baseocom-btn-fold-unfold" onClick={onClickExpandEverything}>
                    {openSubChapter?.expandEverything ? 'Tout replier' : 'Tout déplier'}
                </button>
            ) : null}
            {block?.childrens.map((block, index) => {
                return (
                    <ChapterItem
                        key={index}
                        block={block}
                        index={index}
                        setOpenSubChapter={setOpenSubChapter}
                        openSubChapter={openSubChapter}
                    />
                )
            })}
        </section>
    )
}

export default Chapter
